import { RouterView } from "vue-router";
import { contratMoneyRouter } from "./contractMoney/contractMoney.routing";
import { externalPaymentRouter } from "./externalPayment/externalPayment.routing";
import { depositPaymentRouter } from "./depositPayment/depositPayment.routing";
import { depositBackRouter } from "./depositBack/depositBack.routing";
import { reimburseRouter } from "./reimburse/remibuse.routing";
import { SettlementRouting } from "./contractSettlement/settlement.routing";
export const ProjectPaymentRouting = {
  path: "/projectPayment",
  name: "projectPayment",
  redirect: "/projectPayment/cotractMoney/list",
  component: RouterView,
  meta: { title: "工程款管理（财务）", icon: "projectPayment" },
  children: [
    ...SettlementRouting,
    ...contratMoneyRouter,
    ...externalPaymentRouter,
    ...depositPaymentRouter,
    ...depositBackRouter,
    ...reimburseRouter,
  ],
};
